import { render, staticRenderFns } from "./downlist.vue?vue&type=template&id=db52cd66&scoped=true&"
import script from "./downlist.vue?vue&type=script&lang=js&"
export * from "./downlist.vue?vue&type=script&lang=js&"
import style0 from "./downlist.vue?vue&type=style&index=0&id=db52cd66&scoped=true&lang=css&"
import style1 from "./downlist.vue?vue&type=style&index=1&id=db52cd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db52cd66",
  null
  
)

export default component.exports